import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import FullLogo from '../assets/full-logo.svg';

import OwnerFooter from '../components/OwnerFooter';


function PageNotFound() {
    const history = useHistory();

    return (
        <div className="login-container login-consentowner">
            <div className="content">
                <div className="top d-flex align-items-center">
                    <Link className="logo" to="/"><img src={FullLogo} alt="Logo" /></Link>
                </div>

                <div className="login-area">
                    <div className="inner">
                        <h1>Ooops!</h1>
                        <br />

                        <h3>Denne side findes ikke p&aring; Mitsamtykke.</h3>
                        
                        <button className="btn" onClick={ () => history.push('/') }>G&aring; til start</button>
                        <br /><br />

                        <div className="terms">
                            <p>MitSamtykke er til for DIT samtykkes skyld. Se vores brugsbetingelser <a href="https://www.mitsamtykke.dk/brugervilkaar/" target="_blank" rel="noopener noreferrer">her</a></p>
                        </div>
                    </div>
                </div>

                <OwnerFooter />
            </div>
            <div className="image-container"></div>
        </div>
    );
}

export default PageNotFound;